var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card ranking-width" },
    [
      _c(
        "ul",
        {
          staticClass: "nav nav-tabs justify-content-arround",
          attrs: { role: "tablist" }
        },
        _vm._l(_vm.availableTabs, function(tab) {
          return _c("li", { key: tab.id, staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass: "nav-link",
                class: { active: _vm.currentSelectedTab === tab.id },
                attrs: {
                  href: _vm.getTabName(tab),
                  "data-toggle": "tab",
                  role: "tab",
                  "aria-controls": tab.id,
                  "aria-selected": _vm.currentSelectedTab === tab.id
                },
                on: {
                  click: function($event) {
                    return _vm.getSelectedTab(tab)
                  }
                }
              },
              [_vm._v(" " + _vm._s(tab.title) + " ")]
            )
          ])
        }),
        0
      ),
      _c(_vm.currentTabComponent, {
        tag: "component",
        staticClass: "tab",
        attrs: {
          coders: _vm.visibleCoders,
          "is-mentor": _vm.isMentor,
          "can-choose-coder": _vm.canChooseCoder && !_vm.coderIsSelected
        },
        scopedSlots: _vm._u([
          {
            key: "button-select-coder",
            fn: function(ref) {
              var coder = ref.coder
              return [
                _vm.currentSelectedTab == "candidatesToCoderOfTheMonth" &&
                _vm.isMentor
                  ? _c("td", { staticClass: "text-center align-middle" }, [
                      _vm.canChooseCoder && !_vm.coderIsSelected
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-primary",
                              on: {
                                click: function($event) {
                                  return _vm.$emit(
                                    "select-coder",
                                    coder.username,
                                    _vm.category
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.category == "all"
                                      ? _vm.T.coderOfTheMonthChooseAsCoder
                                      : _vm.T.coderOfTheMonthFemaleChooseAsCoder
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }